import { DataVersion, UnifiedMonitoringProduct } from '@hakimo-ui/hakimo/types';
import { isUnifiedDataVersion } from '../data-version/is-unified-data-version';

/**
 * Builds the Unified Monitoring deep link for one alarm group, in the scheme
 * `parseAlarmGroupPayloads` reads back: v2 ids bucketed by product, v3 ids in
 * `unified`, and `pk` pairing a v3 id with its DB partition. Scan keeps its own
 * bucket even on v3, since it resolves through a different fetch path.
 *
 * Must agree with `buildAlarmGroupParams`, which writes the same scheme -- a
 * link with the wrong key reopens the group against the wrong dataset.
 * `partitionKey` is optional; without it the lookup scans.
 */
export function buildUnifiedMonitoringUrl(
  alarmGroupId: string,
  options: {
    dataVersion?: DataVersion;
    product?: UnifiedMonitoringProduct;
    partitionKey?: string;
  } = {}
): string {
  const { dataVersion, product, partitionKey } = options;
  const isScan = product === UnifiedMonitoringProduct.SCAN;

  if (isUnifiedDataVersion(dataVersion) && !isScan) {
    const pk = partitionKey ? `&pk=${alarmGroupId}:${partitionKey}` : '';
    return `/unified-monitoring?unified=${alarmGroupId}${pk}`;
  }

  const param = isScan
    ? 'scan'
    : product === UnifiedMonitoringProduct.ENTERPRISE
    ? 'ent'
    : 'rg';

  return `/unified-monitoring?${param}=${alarmGroupId}`;
}
